import { useCallback, useState } from 'react'

export type BookingStep = 'start' | 'monthSelect' | 'timeSelect'
export type Direction = 'prev' | 'next'

export const allSteps: BookingStep[] = ['start', 'monthSelect', 'timeSelect']

export const useStepper = <T extends BookingStep[]>(
	visibleSteps = allSteps as T,
	activeStep = visibleSteps[0],
) => {
	const [direction, setDirection] = useState<Direction>('next')
	const [steps] = useState(visibleSteps)

	const activeStepIndex = steps.findIndex((step) => step === activeStep)

	const [stepIndex, setStepIndex] = useState(
		activeStepIndex > -1 ? activeStepIndex : 0,
	)

	const setStep = useCallback(
		(step: BookingStep) => {
			const index = steps.indexOf(step)

			if (index > -1) {
				setStepIndex(index)
			}
		},
		[steps],
	)

	const goBack = useCallback(() => {
		if (stepIndex > 0) {
			setDirection('prev')
			setStepIndex(stepIndex - 1)
		}
	}, [stepIndex])

	const goForward = useCallback(() => {
		if (stepIndex < steps.length - 1) {
			setDirection('next')
			setStepIndex(stepIndex + 1)
		}
	}, [stepIndex, steps.length])

	return {
		direction,
		steps,
		stepIndex,
		setDirection,
		setStepIndex,
		goBack,
		goForward,
		currentStep: steps[stepIndex],
		setStep,
	}
}
